import EditorView from './EditorView/EditorView.component'

export default {
  component: EditorView,
}



// WEBPACK FOOTER //
// ./src/routes/Editor/index.js